import {
  CURRENT_MESSAGES_KEY,
  SELECTED_CONTACT_KEY,
} from './shared/utils/constants';

export const getCurrentMessagesStorage = () =>
  JSON.parse(sessionStorage.getItem(CURRENT_MESSAGES_KEY));

export const setCurrentMessagesStorage = (currentMessages) =>
  sessionStorage.setItem(CURRENT_MESSAGES_KEY, JSON.stringify(currentMessages));

export const setSelectedContactStorage = (selectedContact) =>
  sessionStorage.setItem(SELECTED_CONTACT_KEY, JSON.stringify(selectedContact));

export const getSelectedContactStorage = () =>
  JSON.parse(sessionStorage.getItem(SELECTED_CONTACT_KEY));
